import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { BiTrash } from "react-icons/bi";
import EditableField from './EditableField';
import './InvoiceItem.css';

class InvoiceItem extends React.Component {
  render() {
    var onItemizedItemEdit = this.props.onItemizedItemEdit;
    var currency = this.props.currency;
    var rowDel = this.props.onRowDel;
    var onSubAmount = this.props.onSubAmount;
    var itemTable = this.props.items.map(function(item) {
      return (
        <ItemRow onItemizedItemEdit={onItemizedItemEdit} item={item} onDelEvent={rowDel.bind(this)} key={item.id} currency={currency} onSubAmount={onSubAmount}/>
      )
    });
    return (
      <div>
        <Table className='items-table'>
          <thead>
            <tr>
              <th className="text-[13px] bg-black text-white text-center">ITEM</th>
              <th className="text-[13px] bg-black text-white text-center">QUANTITY</th>
              <th className="text-[13px] bg-black text-white text-center">RATE</th>
              <th className="text-[13px] bg-black text-white text-center">CGST %</th>
              <th className="text-[13px] bg-black text-white text-center">SGST %</th>
              <th className="text-[13px] bg-black text-white text-center">IGST %</th>
              <th className="text-[13px] bg-black text-white text-center">AMOUNT</th>
              <th className="bg-black text-white text-center"></th>
            </tr>
          </thead>
          <tbody>
            {itemTable}
          </tbody>
        </Table>
        <Button className="btn-css fw-bold" onClick={this.props.onRowAdd}>Add Item</Button>
      </div>
    );

  }

}
class ItemRow extends React.Component {
  onDelEvent() {
    this.props.onDelEvent(this.props.item);
  }
  render() {
    return (
      <tr>
        <td style={{width: '100%', fontSize:'13px'}}>
          <EditableField
            onItemizedItemEdit={this.props.onItemizedItemEdit}
            cellData={{
            type: "text",
            name: "name",
            placeholder: "Item name",
            value: this.props.item.name,
            id: this.props.item.id,
          }}/>
        </td>
        <td style={{minWidth: '90px', fontSize:'13px'}}>
          <EditableField
          onItemizedItemEdit={this.props.onItemizedItemEdit}
          cellData={{
            type: "number",
            name: "quantity",
            min: 1,
            step: "1",
            value: this.props.item.quantity,
            id: this.props.item.id,
          }}/>
        </td>
        <td style={{minWidth: '130px', fontSize:'13px'}}>
          <EditableField
            onItemizedItemEdit={this.props.onItemizedItemEdit}
            cellData={{
            leading: this.props.currency,
            type: "number",
            name: "price",
            min: 1,
            step: "0.01",
            presicion: 2,
            value: this.props.item.price,
            id: this.props.item.id,
          }}/>
        </td>
        <td style={{minWidth: '100px', fontSize:'13px'}}>
          <EditableField
            onItemizedItemEdit={this.props.onItemizedItemEdit}
            cellData={{
            type: "number",
            name: "cgst",
            min: 1,
            step: "0.01",
            presicion: 2,
            value: this.props.item.cgst,
            id: this.props.item.id,
          }}/>
        </td>
        <td style={{minWidth: '100px', fontSize:'13px'}}>
          <EditableField
            onItemizedItemEdit={this.props.onItemizedItemEdit}
            cellData={{
            type: "number",
            name: "sgst",
            min: 1,
            step: "0.01",
            presicion: 2,
            value: this.props.item.sgst,
            id: this.props.item.id,
          }}/>
        </td>
        <td style={{minWidth: '100px', fontSize:'13px'}}>
          <EditableField
            onItemizedItemEdit={this.props.onItemizedItemEdit}
            cellData={{
            type: "number",
            name: "igst",
            min: 1,
            step: "0.01",
            presicion: 2,
            value: this.props.item.igst,
            id: this.props.item.id,
          }}/>
        </td>
        <td style={{minWidth: '110px', fontSize:'13px'}}>
          <EditableField
            onItemizedItemEdit={this.props.onItemizedItemEdit}
            cellData={{
            type: "number",
            name: "amount",
            min: 0,
            step: "0.01",
            presicion: 2,
            value: this.props.item.amount,
            id: this.props.item.id,
            readOnly: true
          }}/>
        </td>
        <td className="text-center" style={{minWidth: '30px'}}>
          { <BiTrash onClick={this.onDelEvent.bind(this)} style={{height: '33px', width: '33px', padding: '7.5px'}} className="text-white mt-1 btn btn-danger"/>} 
        </td>
      </tr>
    );

  }

}

export default InvoiceItem;
